import { render, staticRenderFns } from "./HistoricLimit.vue?vue&type=template&id=d6784d08"
import script from "./HistoricLimit.vue?vue&type=script&lang=js"
export * from "./HistoricLimit.vue?vue&type=script&lang=js"
import style0 from "./HistoricLimit.vue?vue&type=style&index=0&id=d6784d08&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports